module.exports = __webpack_public_path__ + "media/images/login/aichi-1840d25d9944ff447b451cfbb1fbdc3d.png";